<!-- 首营商品审核任务 -->
<template>
    <div class='page_content'>
        <processAuditAction ref="processAuditAction"></processAuditAction>
        <el-drawer :close-on-press-escape="true" :visible.sync="showStatus" :with-header="false" append-to-bodycustom-class="drawer_box" direction="ltr" size="100%">
            <firstGoodsAction v-if="showStatus" ref="firstGoodsAction" @drawerCancel="drawerCancel" :actionData="actionData"></firstGoodsAction>
        </el-drawer>
        <subComponents ref="showSelectData"></subComponents>

        <div class="page_content_top">
            <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo" @openFormDesign="openFormDesign"></v-button>
            <div class="page_content_top_line">
                <v-search :flagList="['categoryCode']" v-if="pageShowData.jurHead" :searchList="pageShowData.jurHead.jurconfigform" :getRequestData="getRequestData" @searchData="searchData" @openSearch="openSearch">
                    <template slot="searchInput" slot-scope="{formOneValue}">
                        <el-input v-if="formOneValue.entityField == 'bgmId'" clearable @focus="$refs['showSelectData'].openBox('businessGoodsList', 'bgmId', 'bgmId')" v-model="getRequestData.bgmName"
                                  :maxlength="$store.state.inputLength">
                        </el-input>
                        <el-cascader v-if="formOneValue.entityField == 'categoryCode'" ref="elCascader" :show-all-levels="false" :props="{ emitPath: false,checkStrictly:true }"
                                     v-model="getRequestData[formOneValue.entityField]" :options="categoryList" filterable></el-cascader>
                    </template>
                </v-search>
            </div>
        </div>
        <div class="page_content_center">
            <el-table :row-class-name="rowClassName" size="mini" @selection-change="handleSelectionChange" v-if="pageShowData.jurTableVo" :data="returnData.list" :height="tableHeight" :key="$store.state.tableNum" border style="width: 100%"
                      highlight-current-row>
                <el-table-column type="selection" width="55">
                </el-table-column>
                <template v-for="(tableValye,tableKey) in pageShowData.jurTableVo.jurconfigtable">
                    <el-table-column align="center" v-if="tableValye.isShow==1" show-overflow-tooltip :min-width="tableValye.fieldWeight" :key="tableKey" :prop="tableValye.entityField" :label="tableValye.showField">
                        <template slot-scope="scope">
                            <span v-if="tableValye.fieldType == 'date' && scope.row[tableValye.entityField]">
                                {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                            </span>
                            <span v-else-if="tableValye.fieldType == 'dateTime' && scope.row[tableValye.entityField]">
                                {{ $common.getLocalTime(scope.row[tableValye.entityField], true) }}
                            </span>
                            <span v-else-if="tableValye.isRift == 1">
                                <a @click="toDetail(scope.row[tableValye.riftField])">{{scope.row[tableValye.entityField]}}</a>
                            </span>
                            <span v-else-if="tableValye.entityField == 'bgmActivestatus'">
                                {{$store.state.businessGoodsState[scope.row.bgmActivestatus].name}}
                            </span>
                            <el-tag size="mini" v-else-if="tableValye.entityField == 'ggmState'">
                                {{$common.getIsGsp(tableValye.formatterContent,scope.row.ggmState)}}</el-tag>
                                <el-tag size="mini" v-else-if="tableValye.fieldType == 'formatter'">
                                {{ $common.getIsGsp(tableValye.formatterContent, scope.row[tableValye.entityField]) }}</el-tag>
                            <span v-else>
                                {{scope.row[tableValye.entityField]}}
                            </span>
                        </template>
                    </el-table-column>
                </template>
            </el-table>
        </div>
        <div class="page_content_bottom">
            <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>
        </div>
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
            <SearchScheme ref="searchScheme" :id="seId" :smId="cmId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
        <!-- 自定义设计 -->
        <customDesign ref="customDesign"></customDesign>

    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import firstGoodsAction from "@/components/firstGoodsAction.vue";
export default {
    components: { firstGoodsAction },
    //import引入的组件需要注入到对象中才能使用
    data() {
        //这里存放数据
        return {
            tableHeight: 0,
            getRequestData: {
                bgmId: "",
                bgmName: "",
                page: 1,
                rows: 30,
                stName: "",
            },
            returnData: {
                pages: 0, // 总页数
                total: 0, // 总条数
                pageNum: 0, // 当前页数
                list: [],
            },

            buttonList: [],
            pageShowData: [],

            formDataList: [],
            requesUrl: "",
            showStatus: false,
            actionData: [],
            DialogVisible: false,
            seId: "",
            sField: "",
            cmId: "",
            parentSearchData: {},
            seWidth: 0,
            seTitle: "",
            selectVal: [],
            categoryList: [],
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        "getRequestData.bgmName": {
            handler: function (newValue, oldValue) {
                if (newValue == "") {
                    this.getRequestData.bgmId = "";
                }
            },
            deep: true,
        },
        "getRequestData.stName": {
            handler: function (newValue, oldValue) {
                if (newValue == "") {
                    this.getRequestData.stId = "";
                }
            },
            deep: true,
        },
    },
    //方法集合
    methods: {
        // 表格方法
        rowClassName({ row, rowIndex }) {
            let rowName = ""
            if (row.focuson == 1) {
                rowName = "danger-row"; // 可以通过此处给选中行一个class，给自己需求更改样式
            }
            return rowName; //也可以再加上其他类名 如果有需求的话
        },
        //获取分类
        async categoryquery() {
            let responseData = await this.$http.categoryquery({});
            if (responseData.status == 200) {
                this.categoryList = []
                if (responseData.result.length > 0) {
                    this.categoryList = this.handleJurisdiction(responseData.result)
                }
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 权限处理
        handleJurisdiction(data, id = 0, lev = 0) {
            var son = []
            data.forEach((value, keys) => {
                if (value['parentId'] == id) {
                    value = { ...value }
                    value['id'] = value['id']
                    value['value'] = value['pathCode']
                    value['label'] = value['categoryName']
                    var list = this.handleJurisdiction(data, value['id'], lev + 1);
                    if (list.length >= 1) {
                        value['children'] = this.handleJurisdiction(data, value['id'], lev + 1);
                    }
                    son.push(value)

                }
            })
            return son;
        },
        handleSelectionChange(val) {
            this.selectVal = val
        },
        openFormDesign() {
            let pathInfo = parent.getMenuInfo(this.$route.path)

            this.$refs['customDesign'].openBox(pathInfo.jurId, this.pageShowData, pathInfo.jurName)
        },
        getSeWidth(e) {
            // console.log(e);
            this.seWidth = e + "%";
        },
        getSearchName(e) {
            // console.log(e);
            this.seTitle = e;
        },
        // 检索Id, 索引(表格中), 标识
        openSearch({ sId, index, type, sField }) {
            this.DialogVisible = true
            this.seId = sId
            this.sField = sField
            this.parentSearchData[type] = this.getRequestData[type]
        },
        //检索带回数据
        changeInputModel(val) {
            if (val != "" || val != undefined) {
                this.DialogVisible = false;
                this.paramValue(val)
            }
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(',')
            arr.forEach(item => {
                this.getRequestData[item] = val[item]
            })
        },
        // 子组件触发
        drawerCancel(commitData) {
            this.showStatus = false
            commitData && this.getDataList()
        },
        // 点击穿透字段 传参单号
        toDetail(orderId) {
            if (orderId) {
                // 设置为true 打开穿透组件首页
                var isPenetrate = true;
                // 设置缓存 存入点击单号
                this.resetSetItem("penetrateOrderId", orderId);
                // 与父级跨域通信 传递isPenetrate参数
                window.parent.postMessage({
                    //向窗口发送MessageEvent消息
                    cmd: "returnFormJson",
                    params: {
                        isPenetrate
                    }, //参数
                },
                    "*"
                );
            }
        },
        isShowData(name, value) {
            switch (name) {
                case "bgmId":
                    var dataInfo = sessionStorage.getItem("selectBusinessGoodsEntryInfo");
                    if (dataInfo) {
                        dataInfo = JSON.parse(dataInfo);
                        this.getRequestData.bgmId = dataInfo.bgmId;
                        this.getRequestData.bgmName = dataInfo.bgmName;
                    }

                    break;

                default:
                    this.getRequestData[name] = value;
            }
        },
        getPageInfo() {
            // var ss = parent.getMenuInfo(this.$route.path);
            // this.getDataTest(ss.jurId);
            this.categoryquery()
            this.getDataTest(1614737096791)
        },

        // 获取数据列表
        async getDataTest(ids) {
            let responseData = await this.$http.getJur({
                ids: [ids]
            });
            if (responseData.status == 200) {
                this.getButtonList()
                this.pageShowData = responseData.result;
                var obj = {}
                if (this.pageShowData.jurHead) {
                    obj = this.$common.getSearchData(this.pageShowData.jurHead.jurconfigform, 'page', "rows", 30, false)
                } else {
                    obj = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 30, false)
                }
                for (const key in obj) {
                    this.$set(this.getRequestData, key, obj[key])
                }
                // this.formDataList = this.pageShowData.jurFormVoList
                this.getDataList()
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 动作集合
        async actionSet(actionData) {
            console.log(actionData.actionType);
            if (actionData.actionType != 15) {
                if (this.returnData.list.length <= 0) {
                    this.$message({
                        message: "暂无数据",
                        type: "error",
                    });
                    return false;
                }
                if (this.selectVal.length == 0) {
                    this.$message({
                        message: "请先选择您要操作的数据",
                        type: "error",
                    });
                    return
                }
                var dataInfo
                if (this.selectVal.length == 1) {
                    const result = await this.$http.queryFirstGoodsInfo({
                        ids: [this.selectVal[0].ggmId]
                    })
                    if (result.status == 200) {
                        dataInfo = result.result
                    } else {
                        return this.$message.error(result.message)
                    }
                    this.formDataList = [];
                    if (dataInfo.goodType == 0) {//药品
                        console.log("药品", this.pageShowData)
                        this.pageShowData.jurFormVoList && this.pageShowData.jurFormVoList.forEach((v) => {
                            if (!/(器|其他)/g.test(v.jciName)) this.formDataList.push(v);
                        });
                    } else if (dataInfo.goodType == 1) {//器械
                        console.log("器械", this.pageShowData)
                        this.pageShowData.jurFormVoList && this.pageShowData.jurFormVoList.forEach((v) => {
                            if (!/(商品|其他)/g.test(v.jciName)) this.formDataList.push(v);
                        });
                    } else if (dataInfo.goodType == 2) {//其他
                        console.log("其他", this.pageShowData)
                        this.pageShowData.jurFormVoList && this.pageShowData.jurFormVoList.forEach((v) => {
                            if (!/(商品|器)/g.test(v.jciName)) this.formDataList.push(v);
                        });
                    }
                }
            }
            switch (actionData.actionType) {
                case 4://审核
                    if (this.selectVal.length == 1) {
                        this.actionData = {
                            cate: actionData.actionType,
                            formData: this.formDataList,
                            oldData: dataInfo,
                            orderId: dataInfo.bgmId,
                            printSouce: "",
                            printJurId: "",
                            fatherType: false,
                            type: "",
                        };
                        const res = await this.$http.fromrulequeryByIdToJson({ ids: [1201] });
                        if (res.status == 200) {
                            if (res.result.ruleParam.isAbleEdit == 1) {
                                this.actionData.type = '审核修改'
                                this.actionData.cate = 1
                            }
                        }
                        this.showStatus = true;

                    } else {
                        var arr = []
                        this.selectVal.forEach(item => {
                            arr.push(item.ggmId)
                        })
                        this.$refs["processAuditAction"].openBox(0, arr);
                    }
                    break;
                case 5:
                    if (this.selectVal.length != 1) {
                        return this.$message.error("请勾选一条数据")
                    }
                    this.showStatus = true;
                    this.actionData = {
                        cate: actionData.actionType,
                        formData: this.formDataList,
                        oldData: dataInfo,
                        orderId: dataInfo.bgmId,
                        printSouce: "",
                        printJurId: "",
                        fatherType: false,
                    };
                    break;
                case 15:
                    this.openFormDesign()
                    break;
            }
        },
        openFormDesign() {
            let pathInfo = parent.getMenuInfo(this.$route.path)
            this.$refs['customDesign'].openBox(pathInfo.jurId, this.pageShowData, pathInfo.jurName)
        },
        // 数据搜索
        searchData() {
            this.getRequestData.page = 1;
            this.getDataList();
        },
        // 数据翻页
        setDataPageNumber(val) {
            this.getRequestData.page = val;
            this.getDataList();
        },

        // 切换显示条数
        setDataPageSize(val) {
            this.getRequestData.page = 1;
            this.getRequestData.rows = val;
            this.getDataList();
        },

        // 获取数据列表
        async getDataList() {
            let responseData = await this.$http.getFirstGoodsTask(
                this.getRequestData
            );
            if (responseData.status == 200) {
                this.returnData.list = responseData.result.list;
                this.returnData.pages = responseData.result.pages;
                this.returnData.total = responseData.result.total;
                this.returnData.pageNum = responseData.result.pageNum;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        
        // 获取按钮权限
        async getButtonList() {
            this.buttonList = await this.$common.getActionButton()
            
        },
},
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.requesUrl = this.$store.getters.getConfig.requestUrl;
        this.getPageInfo();
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() { },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_content_tag {
    margin-right: 1rem;
}

.el-tabs--border-card_new {
    height: 85vh;
    overflow-y: scroll;
}
</style>